import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AUTH_TOKEN, REACT_APP_API_PAM_URL, ORG_ID, DOMAIN_ID } from "../../../../constants";
import { logOutUser } from "../../../../common";
import axios from "axios";
import { Button, Input, Row, message, Typography, Space, Steps } from "antd";
import {
  DownloadOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";

const { Text } = Typography;
const { Step } = Steps;

export const OnboardLinuxV2 = () => {
  const [notification, contextHolder] = message.useMessage();
  const [agentToken, setAgentToken] = useState("");
  const [orgId, setOrgId] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [userId, setUserId] = useState("");
  const [uuid, setUuid] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const Local_User_ID = localStorage.getItem("userId");
    const Local_Org_ID = localStorage.getItem("OrgId");
    const Local_Domain_ID = localStorage.getItem("DomainId");

    if (Local_User_ID) setUserId(Local_User_ID);
    if (Local_Org_ID) setOrgId(Local_Org_ID);
    if (Local_Domain_ID) setTenantId(Local_Domain_ID);
    fetchAgentKey();
    generateDynamicUuid();
  }, []);

  const generateEnvFileContent = () => {
    const content = `KEY=LINUX02
MACHINE_KEY=LINUX02
AGENT_TOKEN=${agentToken}
ORG_ID=${orgId}
TENANT_ID=${tenantId}
USER_ID=${userId}
AWS_ACCESS_KEY_ID=AKIATQW4CGR3BATAJ2UL
AWS_SECRET_ACCESS_KEY=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
AWS_REGION=us-west-1
BUCKET_NAME=guacwest
RECORDING_DIR=/anchor_dvr/
TEXT_RECORDING_DIR=/text_recordings/
FILE_NAME=test.guac
BUCKET_NAME_GCS=gto-did-app-dev
STORAGE_AWS_FLAG=true
INSTALL_SERVICES=false
UUID=${uuid}`;
    return content;
  };

  const generateDynamicUuid = () => {
    const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const sections = [8, 4, 4, 4, 12];
    sections.forEach((length) => {
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      result += "-";
    });
    result = result.slice(0, -1);
    setUuid(result);
  };

  const downloadEnvFile = () => {
    const content = generateEnvFileContent();
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "app.env";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    notification.success({ content: "app.env downloaded successfully." });
  };

  const fetchAgentKey = () => {
    let keyData = {
      domainId: DOMAIN_ID(),
      expired: false,
      orgId: ORG_ID(),
    };
    axios
      .post(`${REACT_APP_API_PAM_URL}/endpointUsers/generateAgentkey`, keyData, {
        headers: {
          withCredentials: true,
          "X-Authorization": AUTH_TOKEN(),
        },
      })
      .then((res) => {
        if (res.data) {
          setAgentToken(res.data.agentKey);
        }
      })
      .catch((err) => {
        if (err.response.data.message === "Invalid credentials" || err?.response?.status === 401) {
          notification.error({ content: "Credentials are invalid" });
          logOutUser();
        } else {
          notification.error({ content: "Unable to fetch agent key" });
        }
      });
  };

  return (
    <>
      {contextHolder}
      <div style={{ width: "75%" }}>
        <div
          style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "8px",
          }}
        >
          <h2 className="title" style={{ marginBottom: "1rem" }}>
            Linux Agent Setup
          </h2>
          <Text
            type="secondary"
            style={{ marginBottom: "2rem", display: "block", fontSize: "16px" }}
          >
            Follow these steps to set up the AuthNull agent and configure PAM authentication on your
            Linux machine.
          </Text>

          {/* Agent Onboarding Section */}
          <div style={{ marginBottom: "3rem" }}>
            <div
              style={{
                background: "#f5f5f5",
                padding: "1.5rem",
                borderRadius: "8px",
                marginBottom: "1.5rem",
                borderLeft: "4px solid #1890ff",
              }}
            >
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <Text strong style={{ fontSize: "20px", marginBottom: "1rem", display: "block" }}>
                  Part 1: Agent Onboarding
                </Text>
                <Button
                  type="link"
                  icon={<PlayCircleOutlined />}
                  href="https://customer-4qbnzcoswj67r0b2.cloudflarestream.com/65ef1a7012a0f0e98fd1484931df5726/watch"
                  target="_blank"
                >
                  Watch Tutorial
                </Button>
              </div>
              <Text type="secondary" style={{ marginBottom: "1rem", display: "block" }}>
                Install the AuthNull agent on your Linux machine to enable secure access and
                monitoring.
              </Text>
            </div>
            <Steps direction="vertical" size="small" current={-1}>
            <Step
                title={<Text strong>Download Configuration</Text>}
                icon={<DownloadOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Space style={{ marginTop: "0.5rem" }}>
                      <Button type="primary" onClick={downloadEnvFile} icon={<DownloadOutlined />}>
                        Download app.env
                      </Button>
                    </Space>
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      This file contains your unique configuration details needed for the agent to
                      function properly.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Download Installation Script</Text>}
                icon={<DownloadOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo wget https://github.com/authnull0/windows-endpoint/raw/linux-agent/agent/linux-agent/install_agent.sh -O install_agent.sh"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo wget https://github.com/authnull0/windows-endpoint/raw/linux-agent/agent/linux-agent/install_agent.sh -O install_agent.sh",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      This will download the installation script to your current directory.
                    </Text>
                  </div>
                }
              />
              
              <Step
                title={<Text strong>Make Script Executable</Text>}
                icon={<FileTextOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo chmod +x install_agent.sh"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo chmod +x install_agent.sh",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      This will give the script execution permissions.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Run Installation Script</Text>}
                icon={<FileTextOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo ./install_agent.sh"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo ./install_agent.sh",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      This will install the AuthNull agent on your system.
                    </Text>
                  </div>
                }
              />
             
              <Step
                title={<Text strong>Verify Installation</Text>}
                icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="tail -f /var/log/authnull-agent.log"
                      suffix={
                        <Text
                          copyable={{
                            text: "tail -f /var/log/authnull-agent.log",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Check the logs to ensure the agent is running properly. You should see a
                      message indicating the token is valid.
                    </Text>
                  </div>
                }
              />
            </Steps>
          </div>

          {/* PAM Module Configuration Section */}
          <div>
            <div
              style={{
                background: "#f5f5f5",
                padding: "1.5rem",
                borderRadius: "8px",
                marginBottom: "1.5rem",
                borderLeft: "4px solid #52c41a",
              }}
            >
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <Text strong style={{ fontSize: "20px", marginBottom: "1rem", display: "block" }}>
                  Part 2: PAM Module Configuration
                </Text>
                <Button
                  type="link"
                  icon={<PlayCircleOutlined />}
                  href="https://customer-4qbnzcoswj67r0b2.cloudflarestream.com/65ef1a7012a0f0e98fd1484931df5726/watch"
                  target="_blank"
                >
                  Watch Tutorial
                </Button>
              </div>
              <Text type="secondary" style={{ marginBottom: "1rem", display: "block" }}>
                Configure the PAM module to enable secure authentication for SSH access.
              </Text>
            </div>
            <Steps direction="vertical" size="small" current={-1}>
              <Step
                title={<Text strong>Download & Extract the TAR file</Text>}
                icon={<DownloadOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo wget -O pam_authnull.tar https://github.com/authnull0/windows-endpoint/raw/refs/heads/main/pam_authnull.tar"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo wget -O pam_authnull.tar https://github.com/authnull0/windows-endpoint/raw/refs/heads/main/pam_authnull.tar",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo tar -xvf pam_authnull.tar"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo tar -xvf pam_authnull.tar",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="cd pam"
                      suffix={
                        <Text
                          copyable={{
                            text: "cd pam",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Login to the machine and download the TAR file. Extract it and navigate to the
                      pam directory.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Run Configure Script</Text>}
                icon={<FileTextOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo chmod +x configure"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo chmod +x configure",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo ./configure"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo ./configure",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Enter the ORG_ID and TENANT_ID when prompted.
                    </Text>
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Make the configure script executable and run it to update SSH and PAM
                      settings.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Install the PAM Module</Text>}
                icon={<FileTextOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo make"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo make",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Install the PAM module using the make command.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Uninstallation (Optional)</Text>}
                icon={<FileTextOutlined />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="sudo make uninstall"
                      suffix={
                        <Text
                          copyable={{
                            text: "sudo make uninstall",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      To uninstall the PAM module, run this command.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Test the Setup</Text>}
                icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <ol style={{ marginTop: "0.5rem" }}>
                      <li>Open a terminal on your local machine</li>
                      <li>Connect to the VM using SSH</li>
                      <li>You should see the AuthNull authentication prompt</li>
                      <li>Complete the authentication to gain access</li>
                    </ol>
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      If you see the authentication prompt and can successfully authenticate, your
                      PAM module is configured correctly.
                    </Text>
                  </div>
                }
              />
              <Step
                title={<Text strong>Monitor SSH Logs</Text>}
                icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
                description={
                  <div style={{ marginTop: "0.5rem" }}>
                    <Input
                      style={{ border: "none", backgroundColor: "#fafafa", marginTop: "0.5rem" }}
                      size="large"
                      readOnly
                      value="tail -f /var/log/auth.log"
                      suffix={
                        <Text
                          copyable={{
                            text: "tail -f /var/log/auth.log",
                            tooltips: ["Copy Command", "Copied"],
                          }}
                          style={{ color: "GrayText" }}
                        />
                      }
                    />
                    <Text type="secondary" style={{ marginTop: "0.5rem", display: "block" }}>
                      Check the SSH logs for troubleshooting and to monitor authentication attempts.
                    </Text>
                  </div>
                }
              />
            </Steps>
          </div>

          <Row justify="end" style={{ marginTop: 25 }}>
            <Space size="middle">
              <Button type="primary" onClick={() => navigate("/pam/endpoint")}>
                Finish
              </Button>
            </Space>
          </Row>
        </div>
      </div>
    </>
  );
};
